"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseStatusMapper = void 0;
var enum_mapper_1 = require("../utils/enum-mapper");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var globalTypes_1 = require("../public/generated/globalTypes");
exports.purchaseStatusMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.PurchaseStatus.INITIALIZED] = enums_1.PaymentStatus.INITIALIZED,
    _a[globalTypes_1.PurchaseStatus.PENDING] = enums_1.PaymentStatus.PENDING,
    _a[globalTypes_1.PurchaseStatus.ACTIVE] = enums_1.PaymentStatus.ACTIVE,
    _a[globalTypes_1.PurchaseStatus.EXPIRED] = enums_1.PaymentStatus.DECLINED,
    _a[globalTypes_1.PurchaseStatus.CANCELED] = enums_1.PaymentStatus.CANCELED,
    _a[globalTypes_1.PurchaseStatus.REFUNDED] = enums_1.PaymentStatus.REFUNDED,
    _a[globalTypes_1.PurchaseStatus.SUSPENDED] = enums_1.PaymentStatus.SUSPENDED,
    _a[globalTypes_1.PurchaseStatus.FAILED] = enums_1.PaymentStatus.FAILED,
    _a[globalTypes_1.PurchaseStatus.DECLINED] = enums_1.PaymentStatus.DECLINED,
    _a));
//# sourceMappingURL=purchase-status.js.map